import { FaqItem } from "@/components/screen/global-components/faq/FaqStack";
import { ROUTES } from "@/constants";

export const servicesFAQAccordionItemsStandard: FaqItem[] = [
  {
    id: "standard-vs-enterprise",
    title:
      "What is a standard translation and how does it vary from your enterprise services?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "delivery",
    title: "What will you deliver to me?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
    ],
  },
  {
    id: "modification",
    title: "How do I modify or cancel my order?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
    ],
  },
  {
    id: "specializations",
    title: "What translations do you specialize in?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: "#",
  },
];

export const ServicesFAQAccordionItemsCertified: FaqItem[] = [
  {
    id: "item-1",
    title: "What is a certified translation?",
    description: [
      "A certified translation is an official, word-for-word translation accompanied by a signed certification statement, typically required for legal, governmental, or academic document submissions. These translations are performed by professional, native-speaking translators who guarantee the complete accuracy and linguistic integrity of the original document.",
      "Our certified document translation services are executed by a native-speaking ATA-certified translator in 100+ languages. Your translator will provide a digital word-for-word translation along with a signed certification statement.",
      "We also offer notarized translations, faster turnarounds, and physical mailed copies at checkout.",
    ],
    linkText: "Learn more",
    link: "/notarized-translation",
  },
  {
    id: "item-2",
    title: "When do I need a certified translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-3",
    title: "How do I know if my translation will be accepted?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-4",
    title: "Are your certified translations USCIS-approved?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "item-5",
    title: "What is a notarized translation and when do I need one?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-6",
    title: "Can I request a hard copy with a physical stamp and signature?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-7",
    title: "How long does it take to get a certified translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-8",
    title: "Do I need an apostille for my translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-9",
    title: "Can I certify my own translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
];

const ServicesFAQAccordionItemsNotarized: FaqItem[] = [
  {
    id: "item-1",
    title: "What is a notarized translation?",
    description: [
      "A notarized translation is a certified translation that involves an official notary who must be present to witness the statement of accuracy being signed by the translator. The notary will verify the identity of the translator, witness it being signed, and give it an official stamp.",
      "It’s important to note that some agencies and institutions might require an original hard copy, so it’s good to check your requirements and we always recommend a notarized translation and mailed physical copy if you’re unsure.",
    ],
    linkText: "Get Started",
    link: "/order",
  },
  {
    id: "item-2",
    title: "How fast can you deliver a notarized translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-3",
    title: "When do I need a notarized translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-4",
    title:
      "What’s the difference between a certified and notarized translation?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: "#",
  },
  {
    id: "item-5",
    title: "How much does a notarized translation cost?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-7",
    title: "What are the requirements for a notarized translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-8",
    title: "Can I notarize my own translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
];

const ServicesFAQAccordionItemsUrgent: FaqItem[] = [
  {
    id: "item-1",
    title: "What is the process for an urgent translation?",
    description: [
      "We treat urgent translations the same way we treat every translation, however, we prioritize using triaging for our urgent projects to ensure fast translation delivery.",
      "Our proprietary process includes a minimum of three sets of eyes: your translator who executes the translation, your second translator who edits and proofs the translation, and your own review. Throughout this process, we have built-in quality assurance to validate for accuracy. For enterprise clients, an additional dedicated project manager also reviews your project.",
      "We also offer unlimited free revisions to ensure you are 100% satisfied with the outcome.",
    ],
    linkText: "Get Started",
    link: "/order",
  },
  {
    id: "item-2",
    title: "How quickly will I get my translation?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-3",
    title: "Does a rushed translation impact the quality?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
];

const ServicesFAQAccordionItemsQuality: FaqItem[] = [
  {
    id: "item-1",
    title: "What is your revision policy?",
    description:
      "We offer unlimited free revisions until you are 100% satisfied. Once you accept the translation as final, we no longer offer revisions.",
    linkText: "If you need support, please contact us.",
    link: "/support",
  },
  {
    id: "item-2",
    title: "Can I cancel my order or get a refund if I’m not satisfied?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-3",
    title: "Is AI translation accurate?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
  {
    id: "item-4",
    title: "How do you maintain both quality and speed?",
    description: [
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
      "Our enterprise services accommodate more specialized and custom translations. If you need expertise in a specific industry or use case, have specific formatting needs, have a high-volume or ongoing request, or other more complex or unique requirements, our enterprise option is the best route forward. You’d fill out our form with your details, and someone on our team will be in touch within 24-hours to confirm your personalized options and quote.",
    ],
    linkText: "Learn more",
    link: ROUTES.enterpriseTranslation,
  },
  {
    id: "item-5",
    title: "How do you find and qualify your translators?",
    description:
      "Our standard service is our most basic and straightforward document translation offering. It’s a self-service online order form and payment to initiate your translation. Your translator will deliver a digital editable Microsoft Word document within 24-hours. Start your order now.",
  },
];

export const servicesFAQMap = {
  standard: {
    accordionItems: servicesFAQAccordionItemsStandard,
    footerTitle: "Have more questions? We have answers.",
  },
  certified: {
    accordionItems: ServicesFAQAccordionItemsCertified,
    footerTitle: "Have more questions? Visit our FAQ page for more answers.",
  },
  notarized: {
    accordionItems: ServicesFAQAccordionItemsNotarized,
    footerTitle: "Have more questions? Visit our FAQ page for more answers.",
  },
  urgent: {
    accordionItems: ServicesFAQAccordionItemsUrgent,
    footerTitle: "Have more questions? Visit our FAQ page for more answers.",
  },
  quality: {
    accordionItems: ServicesFAQAccordionItemsQuality,
    footerTitle: "Have more questions? We have answers.",
  },
};
